import React from 'react';


const Info = ({ info }) => (
  <div className="row">
    <div className="col-md-3" align="center">
      <div className="">
        <label className="">
          {info}
        </label>
      </div>
      <br />
    </div>
  </div>
);

export default Info;


// WEBPACK FOOTER //
// ./app/javascript/components/card_details/components/UI/Info.js